module.exports = __webpack_public_path__ + "img/97.4d3ec95e.png";